import { createFileRoute } from "@tanstack/react-router";

/**
 * Public feedback route — bez auth guardu. Token je v URL, server validuje
 * přes publicProcedure. Rate-limiting se provádí na úrovni reverse proxy /
 * výhledově v BullMQ job-level kontrolách.
 */
export const Route = createFileRoute("/zpetna-vazba/$token")({});
